import { DateTime, Interval } from 'luxon';

/**
 * @typedef { import('../objects/Mission').Mission } Mission
 * @typedef {{years: number, days: number}} TotalTime
*/

/**
 * Gets the total time according to Troman rules, a year is always 365 days.
 * @param {Interval[]} intervals
 * @returns {TotalTime}
 */
function getTotalTime(intervals) {
    let merged = Interval.merge(intervals);
    let days = 0;

    for (let interval of merged) {
        let diff = interval.end.diff(interval.start, 'days');
        days = days + Math.floor(diff.days);
    }

    return { years: Math.floor(days / 365), days: days % 365 };
}

/**
 * 
 * @param {Date} dt
 */
function toDateTimeOnlyDate(dt) {
    return DateTime.fromObject({ year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() });
}

/**
 * 
 * @param {Date} dt
 * @param {number} days
 */
export function addCalendarDays(dt, days) {
    if (dt == null) {
        return null;
    }
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + days);
}

/**
 * 
 * @param {Mission[]} missions
 * @param {Date} cutoff (inclusive)
 */
export function getMissionDateDuration(missions, cutoff) {
    let intervals = [];
    let cutoffDateTime = toDateTimeOnlyDate(cutoff).plus({ days: 1 });
    for (let mission of missions) {
        if (mission.Start < cutoff) {
            let start = toDateTimeOnlyDate(mission.Start);

            let end = cutoffDateTime;
            if (mission.End != null && mission.End < cutoff) {
                end = toDateTimeOnlyDate(mission.End).plus({ days: 1 });
            }

            let interval = Interval.fromDateTimes(start, end);
            if (interval.isValid) {
                intervals.push(interval);
            }
        }
    }
    return getTotalTime(intervals);
}

/**
 * 
 * @param {TotalTime} totalTime
 */
export function formatDateDuration(totalTime) {
    if (totalTime == null) return '';

    const years = totalTime.years + ' år';
    const days = totalTime.days + (totalTime.days === 1 ? ' dag' : ' dagar');

    if (totalTime.years === 0) {
        return days;
    } else if (totalTime.days === 0) {
        return years;
    } else {
        return years + ' ' + days;
    }
}